import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Col, Container, Form, Row } from "react-bootstrap";
import PopUP from "../popup/Index";
import bevacizumab from "../../assets/img/Color_bevacizumab_adcdHigh.png";
import yuflymaLogo from "../../assets/img/yuflyma-logo.png";
import adalimumabLogo from "../../assets/img/Adalimumab-aaty_logo.png";
import Eligibility from "./Eligibility";
import { useNavigate, useParams } from "react-router-dom";
import Enrollment from "./Enrollment";
import { useForm } from "react-hook-form";
import SubmittedForm from "./SubmittedForm";
import { useSearchParams } from "react-router-dom";
import { FieldsMetaData } from "../../utilities/FieldsMetaData";
import Helper from "../../utilities/helper";
import { getProductColor, getBorderColor, getProductName } from '../../utilities/productColor';
import moment from "moment";
import { useRef } from "react";
import YuflymaPatient from "../collapsible/YuflymaPatient";
import AdalimumabPatient from "../collapsible/AdalimumabPatient";
import YuflymaHCP from "../collapsible/YuflymaHCP";
import VegzelmaHCP from "../collapsible/VegzelmaHCP";
import VegzelmaPatient from "../collapsible/VegzelmaPatient";
import ZymfentraHCP from "../collapsible/ZymfentraHCP";
import ZymfentraPatient from "../collapsible/ZymfentraPatient";
import SteqeymaHCP from "../collapsible/SteqeymaHCP";
import StobocloHCP from "../collapsible/StobocloHCP";
import OsenveltHCP from "../collapsible/OsenveltHCP";
import AvtozmaHCP from "../collapsible/AvtozmaHCP";
import OmlycloHCP from "../collapsible/OmlycloHCP";

const InquiryForm = () => {
  var [role, setRole] = useState("");
  const [product, setProduct] = useState("");
  let [isPatient, setIsPatient] = useState(true);
  const [searchParams] = useSearchParams();
  const [modalShow, setModalShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [step, setStep] = useState(1);
  const [lastStep, setLastStep] = useState(false);
  const {
    register,
    handleSubmit,
    setError,
    control,
    formState: { errors, isValid, isDirty },
    setValue,
    getValues,
  } = useForm({ mode: "onChange" });
  const navigate = useNavigate();
  const [apiError, setApiError] = useState("");
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState("");
  const [shouldHideDiv, setShouldHideDiv] = useState(false);
  const isiTextRef = useRef(null);

  const location = useLocation();

  const { category } = useParams();
  const isZymfentra = category === "zymfentra";

  const isPaysign = location.pathname.includes('steqeyma') || location.pathname.includes('zymfentra') || location.pathname.includes('osenvelt') 
                    || location.pathname.includes('stoboclo') 
                    || location.pathname.includes('avtozma')
                    || location.pathname.includes('omlyclo');

  useEffect(() => {
    const passedRole = searchParams.get("role");
    if (passedRole) {
      setRole(passedRole);
      passedRole === "patient" ? setIsPatient(true) : setIsPatient(false);
    }
  }, [role, searchParams]);

  const [enroller_type, setEnroller_type] = useState("");
  useEffect(() => {
    const passedRole = searchParams.get("role");
    if (passedRole === "patient") {
      setEnroller_type("1");
    }
    if (passedRole === "prescriber") {
      setEnroller_type("2");
    }
    if (passedRole === "pharmacist") {
      setEnroller_type("3");
    }
  }, [enroller_type, searchParams]);

  const [drug, setDrug] = useState("");
  useEffect(() => {
    if (category === "yuflyma") {
      setDrug("2");
    }
    if (category === "vegzelma") {
      setDrug("1");
    }
    if (category === "adalimumab") {
      setDrug("3");
    }
  }, [category, drug, searchParams]);

  const [benefit_type, setBenefit_type] = useState("");
  useEffect(() => {    
    if (category === "yuflyma" || category === "adalimumab") {
      setBenefit_type("2");
    }
    if (category === "vegzelma") {
      setBenefit_type("4");
    }
  }, [benefit_type, category, searchParams]);


const productName = getProductName(location.pathname);

const productColor = getProductColor(location.pathname);

const borderCssStyle = getBorderColor(location.pathname);



// Per-indication age rules, keyed by category and then by the indication's
// dropdown value. AVTOZMA's rules are unchanged. Each product's keys must stay
// in step with its <option value=""> list in Eligibility.js.
const indicationAgeRules = {
  avtozma: {
    1: { min: 18, message: "Patient must be 18 years of age or older (Rheumatoid Arthritis)" },
    2: { min: 18, message: "Patient must be 18 years of age or older (Giant Cell Arteritis)" },
    3: { min: 2, max: 17, message: "Patient must be between 2 and 17 years of age (Polyarticular JIA)" },
    4: { min: 2, max: 17, message: "Patient must be between 2 and 17 years of age (Systemic JIA)" },
    5: { min: 2, message: "Patient must be 2 years of age or older (Cytokine Release Syndrome)" },
    6: { min: 18, message: "Patient must be 18 years of age or older (COVID-19)" },
    7: { min: 0, message: "" }, // "Other" — no restriction or handle separately
  },
  omlyclo: {
    1: { min: 6, message: "Patient must be 6 years of age or older (Moderate to Severe Persistent Asthma)" },
    2: { min: 18, message: "Patient must be 18 years of age or older (Chronic Rhinosinusitis with Nasal Polyps)" },
    3: { min: 1, message: "Patient must be 1 year of age or older (Food Allergy)" },
    4: { min: 12, message: "Patient must be 12 years of age or older (Chronic Spontaneous Urticaria)" },
    5: { min: 0, message: "" }, // "Other" — no restriction
  },
};


const failAge = (msg) => {
  setModalShow(true);
  setApiError(msg);
  setLoader(false);
  return true; // tells the caller to stop
};

// Category-level age rules (add more categories here as needed)
const categoryAgeRules = {
  zymfentra: { min: 18, message: "Patient must be 18 years of age or older" },
};


  const nextStep = () => {
    if (
      (category === "steqeyma" &&
        getValues("Q_INDICATION_STEQEYMA") === "Choose") ||
      (category === "osenvelt" &&
        getValues("Q_INDICATION_OSENVELT") === "Choose") ||
      (category === "stoboclo" &&
        getValues("Q_INDICATION_STOBOCLO") === "Choose") ||
      (category === "avtozma" &&
        getValues("Q_INDICATION_AVTOZMA") === "Choose")||
      (category === "omlyclo" &&
        getValues("Q_INDICATION_OMLYCLO") === "Choose")||
      ((category === "steqeyma" || category === "stoboclo" || category === "osenvelt" || category === "avtozma" || category === "omlyclo") && getValues("Q_INSURANCE_TYPE") === "Choose") ||
      ((category === "steqeyma" || category === "stoboclo" || category === "osenvelt" || category === "avtozma" || category === "omlyclo") &&
        getValues("Q_HIPAA_PATIENT_RELATIONSHIP") === "Choose") ||
      ((category === "steqeyma" || category === "stoboclo" || category === "osenvelt" || category === "avtozma" || category === "omlyclo") && !getValues("Q_COUNTRY")) ||
      ((category === "steqeyma" || category === "stoboclo" || category === "osenvelt" || category === "avtozma" || category === "omlyclo") && !getValues("Q_AGE_18")) ||
      ((category === "steqeyma" || category === "stoboclo" || category === "osenvelt" || category === "avtozma" || category === "omlyclo") && !getValues("Q_READ_TERMS")) ||
      ((category === "steqeyma" || category === "stoboclo" || category === "osenvelt" || category === "avtozma" || category === "omlyclo") && !getValues("Q_PAT_CONSENT")) ||
      ((category === "steqeyma" || category === "stoboclo" || category === "osenvelt" || category === "avtozma" || category === "omlyclo") && !getValues("Q_TEXT_OPT_IN"))
    ) {
      setError(
        category === "osenvelt" ? "Q_INDICATION_OSENVELT" 
        : category === "stoboclo" ? "Q_INDICATION_STOBOCLO" 
        : category === "steqeyma" ? "Q_INDICATION_STEQEYMA" 
        : category === "avtozma" ? "Q_INDICATION_AVTOZMA" 
        : category === "omlyclo" ? "Q_INDICATION_OMLYCLO" 
        : category === "yuflyma" ? "Q_INDICATION_YUFLYMA" 
        : category === "adalimumab" ? "Q_INDICATION_ADALIMUMAB" 
        : category === "zymfentra" ? "Q_INDICATION_ZYMFENTRA" 
        : "Q_INDICATION_VEGZELMA",
        { type: "focus" },
        { shouldFocus: true }
      );
      return;
    }

    if (isValid && isDirty) {
      setStep(step + 1);
    }
    if (step === 2) {
      setLastStep(true);
    } else {
      setLastStep(false);
    }

    setError(
      category === "osenvelt" ? "Q_INDICATION_OSENVELT" 
      : category === "stoboclo" ? "Q_INDICATION_STOBOCLO" 
      : category === "steqeyma" ? "Q_INDICATION_STEQEYMA" 
      : category === "avtozma" ? "Q_INDICATION_AVTOZMA"       
      : category === "omlyclo" ? "Q_INDICATION_OMLYCLO"       
      : category === "yuflyma" ? "Q_INDICATION_YUFLYMA" 
      : category === "adalimumab" ? "Q_INDICATION_ADALIMUMAB" 
      : category === "zymfentra" ? "Q_INDICATION_ZYMFENTRA" 
      : "Q_INDICATION_VEGZELMA",
      { type: "focus" },
      { shouldFocus: true }
    );
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const handleCancel = () => {
      navigate("/entry/" + category);
  };

  const postDataToRest = async function (formData) {
    setLoader(true);
    // const token = await tokenStore.getToken();
    try {
      setApiError("");
      const postPayload = { ReqType: "ENROLLMENT", Answer: [] };
      var today = new Date();
      var age_now = 0;
      var exact_age = 0;
      var indication = 0;
      for (let key of Object.keys(formData)) {
        let field = FieldsMetaData.find((x) => x.QuestionID === key);
        if (!field) continue;
        let value = formData[key];
        if (field.Datatype.toUpperCase() === "DATETYPE")
          value = moment(value).format("MM/DD/YYYY");
        if (field.QuestionID === "Q_HIPAA_DATE_TIME")
          value = moment().format("YYYYMMDD hh:mm:ss");
        if (field.QuestionID === "Q_BENEFIT_TYPE") value = benefit_type;
        if (field.QuestionID === "Q_ENROLLER_TYPE") value = enroller_type;
        if (field.QuestionID === "Q_DRUG") value = drug;
        if (field.QuestionID === "Q_PHONE")
          value = getValues("Q_PHONE").replace(/\D/g, "");
        if (field.QuestionID === "Q_PHONE_2")
          value = getValues("Q_PHONE_2").replace(/\D/g, "");
        if (field.QuestionID === "Q_PHYSICIAN_PHONE")
          value = getValues("Q_PHYSICIAN_PHONE").replace(/\D/g, "");
        if (field.QuestionID === "Q_PHYSICIAN_FAX")
          value = getValues("Q_PHYSICIAN_FAX").replace(/\D/g, "");
        if (field.QuestionID === "Q_DOB") {
          var birthDate = new Date(value);
          age_now = today.getFullYear() - birthDate.getFullYear();
          // Birthday-aware age, used by the OMLYCLO indication rules below.
          // age_now above is a bare year subtraction, so it reads up to a year
          // high until the birthday passes. Leaving AVTOZMA/VEGZELMA on it is a
          // deliberate product decision: switching them would newly reject
          // patients who pass today. Do not "fix" it without sign-off.
          exact_age = age_now;
          var monthDelta = today.getMonth() - birthDate.getMonth();
          if (
            monthDelta < 0 ||
            (monthDelta === 0 && today.getDate() < birthDate.getDate())
          )
            exact_age--;          
          if (age_now < 18 && category === "vegzelma") {
            setApiError("Patient must be at least 18 years old.");
            setLoader(false);
            return;
          }    
        }
        if (
          field.QuestionID === "Q_INDICATION_AVTOZMA" ||
          field.QuestionID === "Q_INDICATION_OMLYCLO"
        )
          indication = value;        
        if (value)
          postPayload.Answer.push({
            QuestionID: field.QuestionID,
            Datatype: field.Datatype,
            Value: value,
          });
        formData[key] = field.Datatype;
      }

        // 1) Validate category-level rule first
        const categoryRule = categoryAgeRules[category];
        if (categoryRule) {
          if ((categoryRule.min != null && age_now < categoryRule.min) ||
              (categoryRule.max != null && age_now > categoryRule.max)) {
            if (failAge(categoryRule.message || "Patient does not meet the age requirements")) return;
          }
        }


      const indicationRules = indicationAgeRules[category];
      if (indicationRules && indication > 0) {
        const rule = indicationRules[indication];
        // OMLYCLO checks against the birthday-aware age; every other product
        // keeps the legacy year-difference value.
        const ageForRule = category === "omlyclo" ? exact_age : age_now;

        if (
          rule &&
          ((rule.min && ageForRule < rule.min) ||
            (rule.max && ageForRule > rule.max))
        ) {
          setModalShow(true);
          setApiError(rule.message || "Patient does not meet the age requirements for this indication");
          setLoader(false);
          return;
        }
      }       
      console.log("postPayload", postPayload);
      //return;

      const subscriptionKey = Helper.getOCPAPIMSubscriptionKey();
      let usePaySign = isPaysign;
      let postURL = (usePaySign || category === "adalimumab" || category === "vegzelma")
        ? Helper.getSubmitPatientURL()
        : Helper.getRegistrationURL();
      let response = await fetch(postURL, {
        method: "POST",
        body: JSON.stringify(postPayload),
        headers: {
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": subscriptionKey,
        },
      });
      let data = await response.json();
      // console.log("data", data);
      setData(data);
      if ((response.status === 400 && data.data?.[0]?.member_id))
        setData(data.data?.[0]);
      if (response.status === 201 || response.status === 200 || (response.status === 400 && data.data?.[0]?.member_id)) {
        setLoader(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
        return true;
      }
      setLoader(false);
      setApiError(
        data.message.length > 0
          ? data.message
          : "An error has occurred, please call support"
      );
    } catch (error) {
      console.error(error);
      setLoader(false);
      setApiError(
        "A server error occurred while synchronizing the data. Please try later."
      );
    }
    return false;
  };

  const onSubmit = async (data) => {
    if (data && isValid) {
      const isSuccess = await postDataToRest(data);
      if (isSuccess) {
        setStep(step + 1);
        setLastStep(true);
      } else {
        setStep(step);
      }
    } else {
      setLastStep(false);
    }
  };

  // ISI Collapse
  const readLess = () => {
    window.scrollTo(0, 0);
  };

  const collapseText = () => {
    window.scrollTo(0, isiTextRef.current.offsetTop);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isiTextRef.current) {
        const sectionTop = isiTextRef.current.getBoundingClientRect().top + 245;
        const windowHeight = window.innerHeight;

        if (sectionTop <= windowHeight) {
          setShouldHideDiv(true);
        } else {
          setShouldHideDiv(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {lastStep ? (
        <SubmittedForm data={data} />
      ) : (
        <>
          <section
            className={`${
              isPaysign
                ? "r-selection roles-section steqeyma-bg"
                : "rselection roles-section"
            }`}
          >
            {category === "yuflyma" ? (
              <img src={yuflymaLogo} className="bevacizumab" alt="yuflyma" />
            ) : category === "vegzelma" ? (
              <img src={bevacizumab} className="bevacizumab" alt="vegzelma" />
            ) : category === "adalimumab" ? (
              <img
                src={adalimumabLogo}
                className="bevacizumab"
                alt="adalimumab-aaty"
              />
            ) : null}
            <Container>
              <Row className="justify-content-center">
                <Col
                  lg={8}
                  xl={isPaysign ? 9 : 6}
                >
                  {isPaysign ? (
                    <div className="inquiry-content-wrap" style={location.pathname.includes('vegzelma') ? { marginBottom: "100px" } : {}}>
                      <p className="inquiry-title" style={{textAlign : "center"}}>
                        ENROLL NOW TO SAVE ON{" "}
                        <b>
                          <span style={{color: productColor}}>{productName}<sup className="reg">&reg;</sup></span>
                        </b>
                      </p>
                      <p className="inquiry-desc">
                        To determine eligibility for co-pay support, complete
                        the Enrollment Form below.
                      </p>
                    </div>
                  ) : null}
                  <div
                    className={borderCssStyle}
                  >
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      {step === 1 && (
                        <Eligibility
                          isPatient={isPatient}
                          nextStep={nextStep}
                          handleCancel={handleCancel}
                          register={register}
                          errors={errors}
                          setModalShow={setModalShow}
                        />
                      )}

                      {step === 2 && (
                        <Enrollment
                          prevStep={prevStep}
                          handleCancel={handleCancel}
                          register={register}
                          errors={errors}
                          apiError={apiError}
                          step={step}
                          loader={loader}
                          control={control}
                        />
                      )}
                    </Form>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {category === "adalimumab" ? (
            <AdalimumabPatient
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {category === "yuflyma" && role === "patient" ? (
            <YuflymaPatient
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {/* Zymfentra */}
          {category === "zymfentra" && role === "patient" ? (
            <ZymfentraPatient
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {category === "yuflyma" && role !== "patient" ? (
            <YuflymaHCP
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {/* Zymfentra */}
          {category === "zymfentra" && role !== "patient" ? (
            <ZymfentraHCP
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {category === "vegzelma" && role === "patient" ? (
            <VegzelmaPatient
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {category === "vegzelma" && role !== "patient" ? (
            <VegzelmaHCP
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {category === "steqeyma" ? (
            <SteqeymaHCP
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {category === "osenvelt" ? (
            <OsenveltHCP
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {category === "stoboclo" ? (
            <StobocloHCP
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}      

          {category === "avtozma" ? (
            <AvtozmaHCP
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}

          {category === "omlyclo" ? (
            <OmlycloHCP
              shouldHideDiv={shouldHideDiv}
              collapseText={collapseText}
              isiTextRef={isiTextRef}
              readLess={readLess}
            />
          ) : null}                        
        </>
      )}
      <PopUP
        show={modalShow}
        onHide={() => setModalShow(false)}
        isVegzelma={category === "vegzelma"}
        isZymfentra={category === "zymfentra"}
        category={category}
      />
    </>
  );
};

export default InquiryForm;
